import { useCurrentSpace } from "@/hooks/useCurrentSpace"

export const useSpaceAttributionWindow = () => {

    const { space } = useCurrentSpace()

    // When the space's 'Default' attribution switch is on (default when the field is absent),
    // we ignore the configured click/view windows and let the metric extractors take the
    // campaign's default `.value`. Returning an empty array signals that downstream.
    const useDefaultAttribution = space?.useDefaultAttribution !== false
    if (useDefaultAttribution) {
        return { attributionWindowKeys: [] }
    }

    const attributionWindowKeys = []

    if (space.attributionWindowClick) {
        attributionWindowKeys.push(space.attributionWindowClick.key)
    }

    if (space.attributionWindowView) {
        attributionWindowKeys.push(space.attributionWindowView.key)
    }

    return { attributionWindowKeys }


}
